import useFavoritesLists from './use-favorites-lists';

export { useFavoritesLists };

export default useFavoritesLists;
